export const mdl04Urls = {
  getListPrices: '/mdl04/GetPriceList/Post',
  getCochezListPrices: '/mdl04/getCochezPriceList/post',
  saveListPrices: '/mdl04/PriceListCustomer/Post',
  deleteListPrice: '/mdl04/PriceListCustomer/Delete/LinkId?LinkId=',
  getListPricesByCustomer: 'mdl04/PriceListCustomer/Search',
  branchesURL: 'mdl04/searchWarehouse/post',
  supplier: 'mdl04/providerProducts/search',
  allDepartments: 'mdl04/Department/Search',
  productDetailURL: 'mdl04/appMobile/product/detail',
  inventarioURL: 'mdl04/getDetailsInventoryProduct/post',
  warantyURL: '/mdl04/extendedWarranty',
}
